// assets/cart-reload.js
(function () {
  // Only run on the cart page
  if (!document.body.classList.contains('template-cart') && window.location.pathname !== '/cart') return;

  let reloadPending = false;     // set by user interaction only
  let fallbackTimer = null;

  function submitCartForm() {
    const form =
      document.querySelector('form[action="/cart"]') ||
      document.getElementById('cart') ||
      document.querySelector('form#cart');
    if (form) {
      try { form.removeAttribute('data-ajax'); } catch (e) {}
      form.noValidate = true;
      form.submit(); // full page nav if theme doesn't use AJAX
    } else {
      // last-resort
      window.location.replace('/cart');
    }
  }

  // ---- Intercept cart AJAX, but only act when reloadPending === true
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const hitsCartAPI = /\/cart\/(change|update)\.js(\?|$)/.test(url);

    return nativeFetch(input, init).then((resp) => {
      if (reloadPending && hitsCartAPI) {
        reloadPending = false;
        if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
        // Let the server respond, then hard refresh
        resp.clone().text().finally(() => window.location.replace('/cart'));
      }
      return resp;
    });
  };

  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__hitsCartAPI = /\/cart\/(change|update)\.js(\?|$)/.test(url || '');
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('loadend', () => {
      if (reloadPending && this.__hitsCartAPI) {
        reloadPending = false;
        if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
        window.location.replace('/cart');
      }
    });
    return origSend.apply(this, arguments);
  };

  // ---- Mark user intent and trigger an update
  function onUserQtyChange() {
    reloadPending = true;

    // If theme uses AJAX, our hooks above will catch it.
    // If not, submit the form to force a page reload.
    submitCartForm();

    // As a safety net, if nothing navigates within 1.5s, hard refresh.
    if (fallbackTimer) clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(() => {
      if (reloadPending) {
        reloadPending = false;
        window.location.replace('/cart');
      }
    }, 1500);
  }

  // Bind to typical qty controls
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="updates[]"], input[name^="updates"], input[data-qty-input]')) {
      onUserQtyChange();
    }
  });

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('[data-qty-plus]') ||
      e.target.closest('[data-qty-minus]') ||
      e.target.closest('.quantity__button')
    ) {
      // Give the button a tick to update the input, then act
      setTimeout(onUserQtyChange, 60);
    }
  });
})();
